import React, { createContext, useCallback, useState, useContext } from 'react';
import decode from 'jwt-decode';
import api from '../services/api';

interface AuthState {
  token: string;
  user: object;
}

interface SignInCredentials {
  email: string;
  password: string;
}

interface AuthContextData {
  user: object;
  singIn(credentials: SignInCredentials): Promise<void>;
  singOut(): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const token = localStorage.getItem('@GoBarber:token');
    const user = localStorage.getItem('@GoBarber:user');
    if (token && user) {
      return { token, user: JSON.parse(user) };
    }

    return {} as AuthState;
  });
  const singIn = useCallback(async ({ email, password }) => {
    const response = await api.post('login', {
      login: email,
      password,
    });
    const { token } = response.data;

    const decodificate: any = decode(token);
    const user = decodificate.usr.stripe_id;
    const user_id = decodificate.usr.id;

    localStorage.setItem('@ARecreativa:token', token);
    localStorage.setItem('@ARecreativa:user', user);
    localStorage.setItem('@ARecreativa:user_id', user_id);

    setData({ token, user });
  }, []);

  const singOut = useCallback(() => {
    localStorage.removeItem('@ARecreativa:token');
    localStorage.removeItem('@ARecreativa:user');
    localStorage.removeItem('@ARecreativa:user_id');

    setData({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider value={{ user: data.user, singIn, singOut }}>
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuth };
